<div id="main-container" class="container-fluid">
    <div class="material-analysis-page">
        <div class="row ship-weeks row-20 vacc_loc">
            <div class="search-criteria">
                <h4>Ship-To-Schedule: Marketing Analysis Tool </h4>
                <div class="col d-flex border-bottom">
                    <section class="col-md-8 col-sm-12 col-xs-12 section-left">
                        <div class="row">
                            <form [formGroup]="stsMarketingAnalysisForm" id="stsMarketingToolAnalysisForm"
                                (ngSubmit)="onSearch()">
                                <h4 class="search-heading">Search Criteria :</h4>
                                <p class="ml20">Select the search criteria below to find reservations</p>

                                <div class="row">
                                    <div class="col-md-6 col-sm-12 col-xs-12 border-right">
                                        <div class="form-group">
                                            <div class="col-4">
                                                <label class="Fields-label res-no" for="orderNumber">Reservation Number
                                                </label>
                                            </div>
                                            <div class="col">
                                                <input type="text" id="orderNumber"
                                                    class="Fields-input field-optional form-control"
                                                    formControlName="orderNumber">
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div class="col-4">
                                                <label class="Fields-label mt5 materials-label">Material(s) </label>
                                            </div>
                                            <div class="col">
                                                <ng-select id="materials" class="w-100" [closeOnSelect]="false"
                                                    placeholder="Nothing Selected" formControlName="materialNumber"
                                                    [clearable]="false" [multiple]="true"
                                                    (change)="changeView('materials', $event)">
                                                    <ng-option *ngFor="let number of materialNumberOptions"
                                                        [value]="number">{{number}}
                                                    </ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-sm-12 col-xs-12">

                                        <div class="form-group">
                                            <div class="col-4">
                                                <label class="Fields-label res-no">Customer Number </label>
                                            </div>
                                            <div class="col">
                                                <input type="text" id="customerNumber" formControlName="customerNumber"
                                                    class="Fields-input field-optional">
                                            </div>
                                        </div>


                                        <div class="form-group">
                                            <div class="col-4">
                                                <label class="Fields-label mt5 materials-label">Program Level: </label>
                                            </div>
                                            <div class="col">
                                                <ng-select id="programlevel" class="w-100"
                                                    formControlName="programLevel">
                                                    <ng-option value="All"> All</ng-option>
                                                    <ng-option *ngFor="let level of programLevelList" [value]="level">
                                                        {{level}}
                                                    </ng-option>
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div class="col-4">
                                                <label class="Fields-label mt5 materials-label">Mseg: </label>
                                            </div>
                                            <div class="col">
                                                <ng-select id="multi-select-mseg" class="w-100" [closeOnSelect]="false"
                                                    placeholder="Nothing Selected" formControlName="mseg"
                                                    [multiple]="true"
                                                    (change)="changeView('multi-select-mseg', $event);">
                                                    <ng-option *ngFor="let mseg of msegList" [value]="mseg.key">
                                                        {{mseg.key}}
                                                    </ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <button type="submit"
                                                class="btn-primary float-right marketing-tool-search">Search</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>


                    <aside class="col-md-4 col-sm-12 col-xs-12 section-right">
                        <h4 class="search-heading pb-20">Search Result Statistics : </h4>
                        <p class="summary">Total Average Variance: <span
                                class="variance">{{totalAverageVariance}}</span></p>
                        <p class="summary">Requested Units: <span class="requested">{{sapTotalUnits}}</span> </p>
                        <p class="summary">SAP total Units: <span class="sapUnits">{{requestedUnits}}</span></p>
                    </aside>

                </div>
            </div>
        </div>
        <div class="col" *ngIf="marketingListData">
            <div class="col d-flex justify-content-end mb-4">
                <button class="btn-primary marketing-tool-search" (click)="downloadStsXls()">Export</button>
                <button class="btn-primary marketing-tool-search ml-4" (click)="downloadStsXls()">Export Mass</button>
            </div>
            <div class="col">
                <table id="sts-marketing-table">
                    <tbody>
                        <tr>
                            <td>
                                <table id="backoffice-table"
                                    class="backoffice-table marketing-analysis display table-1">
                                    <thead>
                                        <tr>
                                            <th colspan="10"></th>
                                        </tr>
                                        <tr>
                                            <th colspan="10" class="text-right">Totals:</th>
                                        </tr>
                                        <tr>
                                            <th class="heading">Level</th>
                                            <th class="heading">Customer</th>
                                            <th class="heading">Reservation</th>
                                            <th class="heading">Presentation</th>
                                            <th class="heading">Requested</th>
                                            <th class="heading">SAP Total</th>
                                            <th class="heading">Units change</th>
                                            <th class="heading">Ship change</th>
                                            <th class="heading">Ship Accuracy</th>
                                            <th class="heading">Variance</th>
                                        </tr>
                                    </thead>
                                    <tbody class="datatable-row">
                                        <tr class="week-table-row red"
                                            *ngFor="let marketingData of marketingListData; let i = index;">
                                            <td class="text-center">{{marketingData.key.progLevel}}</td>
                                            <td class="text-center">{{marketingData.key.customerNumber}}</td>
                                            <td class="text-center">{{marketingData.key.orderNumber}}</td>
                                            <td class="text-center">{{marketingData.key.materialNumber}}</td>
                                            <td class="text-center">{{marketingData.key.requested}}</td>
                                            <td class="text-center">{{marketingData.key.sapTotal}}</td>
                                            <td class="text-center">{{marketingData.key.unitChange}}</td>
                                            <td class="text-center">{{marketingData.key.shipChange}}</td>
                                            <td class="text-center">{{marketingData.key.shipAcuracy}}</td>
                                            <td class="text-center">{{marketingData.key.variance}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td>
                                <table id="backoffice-table"
                                    class="backoffice-table marketing-analysis display table-2 tableScrollable">
                                    <thead>
                                        <tr>
                                            <th colspan="2" class="heading"
                                                *ngFor="let week of weekList; let j = index;"> Week of {{week}}</th>
                                        </tr>
                                        <tr>
                                            <ng-container
                                                *ngFor="let shippingData of marketingListData[0].value.shippingData;">
                                                <td class="text-center">{{shippingData.totalOriginal}}</td>
                                                <td class="text-center">{{shippingData.totalUpdated}}</td>
                                            </ng-container>
                                        </tr>
                                        <tr>
                                            <ng-container *ngFor="let week of weekList; let j = index;">
                                                <th class="heading">Original</th>
                                                <th class="heading">Updated</th>
                                            </ng-container>
                                        </tr>
                                    </thead>
                                    <tbody class="datatable-row">
                                        <tr class="week-table-row" *ngFor="let marketingData of marketingListData;">
                                            <ng-container
                                                *ngFor="let shippingData of marketingData.value.shippingData;">
                                                <td class="text-center"
                                                    [ngClass]="shippingData.quantity == 0 ? 'bgRed' : 'bgGreen'">
                                                    {{shippingData.quantity}}</td>
                                                <td class="adjust-quanity"
                                                    [ngClass]="shippingData.adjustedquantity > 0 ? 'bgGreen' : 'bgRed'">
                                                    <input type="text" class="inputSize"
                                                        [(ngModel)]="shippingData.adjustedquantity"
                                                        [ngClass]="shippingData.adjustedquantity > 0 ? 'bgGreen' : 'bgRed'">
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col">
                <button class="btn-primary marketing-tool-search" (click)="saveSTSMarketingDetails()">Save</button>
            </div>
        </div>
    </div>
</div>